import { BaseModel } from '@app/shared/models/base';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class Country extends BaseModel {
    public code: string;
    public value: string;
    public sortOrder: number;

    public readonly trans = {
        name: marker('country.name')
    };

    constructor(json?: any) {
        super(json);
    }
}
